import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Theme } from '@interfaces/global';
import { newsletter_list_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import Button from '../../Button';

const SEE_ALL_NEWSLETTERS_TEXT = 'See all newsletters';

interface NewsletterOptionProps {
  className?: string;
  theme?: Theme;
}

const NewsletterOption = ({ className, theme }: NewsletterOptionProps) => {
  const { trackEvent } = useEventTracking();
  return (
    <div
      className={clsx(className, {
        'text-grayscale-beige': theme === Theme.Dark,
        'text-grayscale-gray': theme === Theme.Light,
      })}
    >
      <Button
        className={clsx(
          'font-suisse-screen text-disclosure-sm text-overline-sm underline underline-offset-4 opacity-50 transition-all hover:border-primary-magenta hover:text-primary-magenta hover:opacity-100 focus:border-primary-magenta focus:text-primary-magenta dark:text-primary-pink dark:opacity-100 dark:hover:text-primary-pink',
          {
            'text-grayscale-beige': theme === Theme.Dark,
            'text-grayscale-gray': theme === Theme.Light,
          }
        )}
        as="link"
        href={newsletter_list_path()}
        onClickCapture={() =>
          trackEvent(
            click({
              clickTarget: ClickTarget.SeeAllNewsletters,
              clickText: SEE_ALL_NEWSLETTERS_TEXT,
            })
          )
        }
      >
        {SEE_ALL_NEWSLETTERS_TEXT}
      </Button>
    </div>
  );
};

export default NewsletterOption;
